export var CLASSNAME_PREFIX = 'av-scenarios-container';
export var TRANSLATION_CONTEXT = 'accountverification';
//# sourceMappingURL=componentConfig.js.map